import { render, staticRenderFns } from "./GptChat.vue?vue&type=template&id=23804c4c&scoped=true"
import script from "./GptChat.vue?vue&type=script&lang=js"
export * from "./GptChat.vue?vue&type=script&lang=js"
import style0 from "./GptChat.vue?vue&type=style&index=0&id=23804c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23804c4c",
  null
  
)

export default component.exports